import AdminCenter from '@/views/AdminCenter.vue';
import CreateSchool from '@/views/CreateSchool.vue';
import EditSchool from '@/views/EditSchool.vue';
import SchoolAdmins from '@/views/SchoolAdmins.vue';
import SchoolDirectory from '@/views/SchoolDirectory.vue';
import SchoolInformation from '@/views/SchoolInformation.vue';
import SchoolProfile from '@/views/SchoolProfile.vue';
import LockoutReport from '@/views/LockoutReport.vue';

export default [
    {
        path: '/admin',
        name: 'adminCenter',
        component: AdminCenter,
        meta: { adminCenter: true },
        children: [
            {
                path: 'schools',
                children: [
                    {
                        path: '',
                        name: 'schoolDirectory',
                        component: SchoolDirectory,
                        props: true,
                    },
                    {
                        path: 'create',
                        name: 'createSchool',
                        component: CreateSchool,
                    },
                    {
                        path: ':schoolSlug',
                        name: 'schoolInfo',
                        component: SchoolInformation,
                        children: [
                            {
                                path: '',
                                name: 'schoolProfile',
                                component: SchoolProfile,
                                props: true,
                            },
                            {
                                path: 'edit',
                                name: 'editSchool',
                                component: EditSchool,
                                props: true,
                            },
                            {
                                path: 'admins',
                                name: 'admins',
                                component: SchoolAdmins,
                                props: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'lockout-report',
                name: 'lockoutReport',
                component: LockoutReport,
                meta: { displayName: 'Lockout Report' },
            },
        ],
    },
];
